import { Skeleton } from '@mui/material';
import { DealRequestAllocation } from '../../shared/models';
import { DebtEquipment } from './DebtEquipment';
import { DebtGrowthCapital } from './DebtGrowthCapital';
import { DebtOtherFinancingNeeds } from './DebtOtherFinancingNeeds';
import { DebtRealEstate } from './DebtRealEstate';
import { DebtRefinance } from './DebtRefinance';
import { DebtWorkingCapital } from './DebtWorkingCapital';
import { DebtAcquiringBusiness } from './DebtAcquiringBusiness';

interface RequestInformationProps {
	isLoading: boolean;
	allocation: DealRequestAllocation | null | undefined;
}

export const RequestInformation: React.FC<RequestInformationProps> = ({ isLoading, allocation }) => {
	if (isLoading) {
		return (
			<>
				<Skeleton height={400} />
				<Skeleton height={400} />
			</>
		);
	}

	return (
		<>
			{allocation?.acquiringBusiness === true ? <DebtAcquiringBusiness allocation={allocation} /> : <></>}

			{allocation?.purchaseWorkingCapital === true ? <DebtWorkingCapital allocation={allocation} /> : <></>}

			{allocation?.financeExpensesOrGrowth === true ? <DebtGrowthCapital allocation={allocation} /> : <></>}

			{allocation?.purchaseEquipment === true ? <DebtEquipment allocation={allocation} /> : <></>}

			{allocation?.purchaseRealEstate === true ? <DebtRealEstate allocation={allocation} /> : <></>}

			{allocation?.refinanceExistingDebt === true ? <DebtRefinance allocation={allocation} /> : <></>}

			{allocation?.otherFinancingNeeds === true ? <DebtOtherFinancingNeeds allocation={allocation} /> : <></>}
		</>
	);
};
